import { createFileRoute } from "@tanstack/react-router";
import SpendByProduct from "@/components/AccountsSpend/SpendByProduct";

function RouteComponent() {
  return <SpendByProduct />;
}

export const Route = createFileRoute("/_authenticated/accounts/spend-by-product")({
  component: RouteComponent,
  staticData: { page: ["accounts", "sales", "finance", "deals"] },
});
